import { Outlet } from 'react-router-dom';

export const Settings = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};
